import createCtx from '../../helpers/createCtx';

export const [useSegmentTracker, SegmentTrackingContext] = createCtx(
  'SegmentTrackingContext',
);
